import React, { FC } from 'react';

import { type DropzoneOptions, useDropzone } from 'react-dropzone';
import c from 'react-syntax-highlighter/dist/esm/languages/hljs/c';
import { cn } from 'utils/helpers';

const defaultDropzoneProps: DropzoneOptions = {
  maxSize: c.MAX_UPLOAD_SIZE,
  noClick: true,
  noKeyboard: true,
};

type FileDropZoneProps = DropzoneOptions & {
  children: (props: { open: () => void }) => React.ReactNode;
};

const FileDropZone: FC<FileDropZoneProps> = ({
  children,
  ...dropzoneProps
}) => {
  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    ...defaultDropzoneProps,
    ...dropzoneProps,
  });
  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {children({ open })}
      {isDragActive && (
        <div
          className={cn(
            'absolute inset-y-0 left-0',
            'bg-fill-tertiary',
            'bg-opacity-90',
            'h-full w-full',
            'grid place-items-center',
            'border-2 border-dashed border-secondary',
          )}
        >
          <div className="text-lg">Drop Files Here</div>
        </div>
      )}
    </div>
  );
};

export default FileDropZone;
